import { Home, MapPin, ArrowLeft } from "lucide-react";

export function RelocationNotFoundScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="w-full max-w-md text-center">
        {/* Animated 404 */}
        <div className="mb-8">
          <div className="mb-2 animate-bounce text-8xl font-bold text-indigo-600">
            404
          </div>
          <div className="flex items-center justify-center gap-2 text-gray-600">
            <MapPin className="h-5 w-5" />
            <span className="text-lg">Location Not Found</span>
          </div>
        </div>

        {/* Main message */}
        <div className="mb-8">
          <h1 className="mb-3 text-2xl font-semibold text-gray-800">
            Oops! This relocation doesn&apos;t exist
          </h1>
          <p className="leading-relaxed text-gray-600">
            The relocation record you&apos;re looking for might have been moved,
            deleted, or the URL might be incorrect.
          </p>
        </div>

        {/* Action buttons */}
        <div className="space-y-3">
          <button
            onClick={() => window.history.back()}
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-indigo-600 px-6 py-3 font-medium text-white transition-colors duration-200 hover:bg-indigo-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </button>

          <button
            onClick={() => (window.location.href = "/")}
            className="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-6 py-3 font-medium text-gray-700 transition-colors duration-200 hover:bg-gray-50"
          >
            <Home className="h-4 w-4" />
            Return Home
          </button>
        </div>

        {/* Helpful links */}
        <div className="mt-8 border-t border-gray-200 pt-6">
          <p className="mb-3 text-sm text-gray-500">Need help?</p>
          <div className="flex justify-center gap-4 text-sm">
            <a
              href="/relocations"
              className="text-indigo-600 transition-colors hover:text-indigo-800"
            >
              View All Relocations
            </a>
            <span className="text-gray-300">|</span>
            <a
              href="/support"
              className="text-indigo-600 transition-colors hover:text-indigo-800"
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
